import React from "react";
import MUITable from "../../../../Common/MUITable";
import Loader from "../../../../Common/Loader/loader";
import isGHMC, { formatDateTimeWithoutSec, getCurrentDateTime,formattedDate } from "../../../../Common/helper/helpar";
import { HygieneTransportationFilter } from "./HygieneReportFilter";
import HygienicTransportationStore from "./store/HygieneStore";

export const HygieneTransportationReport = () => {
  const { loading, hygienicReportData } = HygienicTransportationStore();
  const isProd = isGHMC();
  const currentDate = getCurrentDateTime();

  const storedFilters = localStorage.getItem("hygieneTransportationFilters");
  const parsedFilters = storedFilters ? JSON.parse(storedFilters) : {};

  /* ================= DATE FORMATTER ================= */
  const formatDateTime = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return "-";

    return date
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(/\//g, "-");
  };

  /* ================= REMOVE BLANK ROW ================= */
  const filteredData = React.useMemo(() => {
    return (hygienicReportData || []).filter((row) => {
      const hasValidDate = row.Date && row.Date !== "-";
      const hasTrips =
        Number(row.TotalHygienicVehicleTrips || 0) > 0 ||
        Number(row.TotalTrips || 0) > 0;

      return hasValidDate && hasTrips;
    });
  }, [hygienicReportData]);

  /* ================= TOTAL ROW ================= */
  const totalRow =
    filteredData.length > 0
      ? {
          Date: "Total",
          TotalHygienicVehicleTrips: filteredData.reduce(
            (sum, row) => sum + Number(row.TotalHygienicVehicleTrips || 0),
            0
          ),
          TotalTrips: filteredData.reduce(
            (sum, row) => sum + Number(row.TotalTrips || 0),
            0
          ),
        }
      : null;

  /* ================= TABLE COLUMNS ================= */
  const hygienicReportHeaderColumns = [
    {
      label: "Date",
      field: "Date",
      width: 100,
      render: (row) => (
        <div style={{ fontWeight: row.Date === "Total" ? "bold" : "normal" }}>
          {row.Date === "Total" ? "Total" : formattedDate(row.Date)}
        </div>
      ),
    },
    {
      label: (
        <>
          Total number of vehicle Trips in <br />
          Hygienic condition from the TS/SCTP's
        </>
      ),
      field: "TotalHygienicVehicleTrips",
      render: (row) => (
        <div style={{ fontWeight: row.Date === "Total" ? "bold" : "normal" }}>
          {row.TotalHygienicVehicleTrips ?? 0}
        </div>
      ),
    },
    {
      label: (
        <>
          Total number of vehicle Trips <br />
          Hygienic condition deployed from the TS/SCTP's
        </>
      ),
      field: "TotalTrips",
      render: (row) => (
        <div style={{ fontWeight: row.Date === "Total" ? "bold" : "normal" }}>
          {row.TotalTrips ?? 0}
        </div>
      ),
    },
    {
      label: "Performance Achieved (%)",
      field: "PerformanceAchievedPercentage",
      render: (row) => {
        // if (row.Date === "Total") {
        //   // return <div style={{ fontWeight: "bold" }}>-</div>;
        // }
        return <div>{row.PerformanceAchievedPercentage}</div>;
      },
    },
       {
      label: "Description",
      field: "Description",
      render: (row) => {
        return <div>{row.Description}</div>;
      },
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <HygieneTransportationFilter />

          <div className="card mt-3">
            <div className="card-body">
              <div
                className="top-header p-2"
                style={{
                  backgroundColor: "#D7D7D7",
                  fontWeight: 600,
                  borderBottom: "1px solid #DDDDDD",
                }}
              >
                <span>
                  Hygienic Transportation Report as on 
                  {parsedFilters?.FromDate && parsedFilters?.ToDate
                    ? ` (${formattedDate(parsedFilters.FromDate)} to ${formattedDate(parsedFilters.ToDate)})`
                    : ""} at ({formattedDate(currentDate)})
                      
                </span>
              </div>

              {loading ? (
                <Loader />
              ) : (
                <MUITable
                  needSRNumber
                  hasTotalRow
                  tableHeight={500}
                  columns={hygienicReportHeaderColumns}
                  rows={
                    totalRow
                      ? [...filteredData, totalRow]
                      : filteredData
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
